// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WebsiteGeneratorForm.css */

.generator-form {
  background-color: var(--bg-color, #fff);
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  margin: 40px auto;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  font-size: 1rem;
}

.generator-form h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #444;
}

.generator-form label {
  display: block;
  margin: 1rem 0 0.5rem;
  font-weight: 600;
}

.generator-form input,
.generator-form select,
.generator-form textarea {
  width: 100%;
  padding: 0.8rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  background-color: var(--white-color, #fff);
}

.generator-form button {
  margin-top: 1.5rem;
  padding: 1rem 2rem;
  font-size: 1rem;
  background-color: #5a4ff3;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.generator-form button:hover {
  background-color: #4338ca;
}


`, "",{"version":3,"sources":["webpack://./src/components/WebsiteGeneratorForm.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* WebsiteGeneratorForm.css */\n\n.generator-form {\n  background-color: var(--bg-color, #fff);\n  padding: 2rem;\n  border-radius: 12px;\n  max-width: 600px;\n  margin: 40px auto;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.1);\n  font-size: 1rem;\n}\n\n.generator-form h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #444;\n}\n\n.generator-form label {\n  display: block;\n  margin: 1rem 0 0.5rem;\n  font-weight: 600;\n}\n\n.generator-form input,\n.generator-form select,\n.generator-form textarea {\n  width: 100%;\n  padding: 0.8rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n  background-color: var(--white-color, #fff);\n}\n\n.generator-form button {\n  margin-top: 1.5rem;\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  background-color: #5a4ff3;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.generator-form button:hover {\n  background-color: #4338ca;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
